<template>
  <NotificationBell
    ref="bell"
    :notifications="notifications"
    :loading="!!notificationsStatus.loading"
    :error="notificationsStatus.error ? 'No se han podido actualizar las notificaciones.' : ''"
    :downloading-id="fileStatus.downloading ? fileId : null"
    @open="loadNotifications"
    @refresh="refreshNotifications"
    @close="cancelDownload"
    @download="downloadAttachment"
  />
</template>

<script>
import NotificationBell from "@/components/Notifications/NotificationBell.vue";
import { downloadFile } from "@/util/utils";

export default {
  name: "NotificationsMenu",
  components: { NotificationBell },
  data() {
    return { notifications: [], pendingFileId: null };
  },
  computed: {
    notificationsStatus() {
      return this.$store.state.dashboard.notifications.status;
    },
    fileStatus() {
      return this.$store.state.dashboard.file.status;
    },
    fileId() {
      return this.$store.state.dashboard.file.id;
    },
  },
  mounted() {
    this.loadNotifications();
  },
  methods: {
    loadNotifications() {
      this.$store.dispatch("dashboard/getNotifications");
    },
    refreshNotifications() {
      this.$store.dispatch("dashboard/getNotifications", { force: true });
    },
    downloadAttachment(id) {
      if (this.fileStatus.downloading || !id) return;
      this.pendingFileId = id;
      this.$store.dispatch("dashboard/getNotificationFile", id);
    },
    cancelDownload() {
      this.pendingFileId = null;
    },
  },
  watch: {
    notificationsStatus: {
      immediate: true,
      handler() {
        this.notifications = this.$store.state.dashboard.notifications.data;
      },
    },
    fileStatus(status) {
      if (!this.pendingFileId || this.pendingFileId !== this.fileId) return;
      if (status.downloaded) {
        const data = this.$store.state.dashboard.file.data;
        this.pendingFileId = null;
        downloadFile({ blob: data.file, fileName: data.filename || "adjunto" });
      } else if (status.error) {
        this.pendingFileId = null;
        this.$notify({
          title: "Notificaciones",
          message: "No se ha podido descargar el adjunto. Inténtalo de nuevo.",
          type: "danger",
        });
      }
    },
    $route() {
      this.$refs.bell.close();
      this.cancelDownload();
    },
  },
};
</script>
